import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import LogoKrause from "../../assets/logo/logo-grupo-krause.png";
import MainImgAbout from "../../assets/images/main-img-about.webp";
import "./AboutCall.css";

export default function AboutCall(props) {
  return (
    <Container className="about-section">
      <Row>
        <Col className="about-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <img src={LogoKrause} alt="Logo Grupo" />
            CONHEÇA O GRUPO KRAUSE
          </h2>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="about-third-col">
          <h3 style={{ color: props.titleColor, fontSize: props.subTitleSize }}>
            As famílias do Vale dos Sinos e região têm apoio para viver uma vida
            com mais valor
          </h3>
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Há mais de 100 anos, o Grupo Krause é a melhor e mais completa opção
            de serviços de luto de toda região.
          </p>
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            São serviços que garantem apoio, sempre respeitando o ser humano e
            valorizando a vida.
          </p>
          <CustomButton
            className="primary-btn"
            variant="primary"
            href="/quem-somos/"
            icon=""
            content="SAIBA MAIS"
            backgroundColor={props.btnColor}
            fontFamily="Unageo-Bold"
            fontColor={props.white}
            fontSize={20}
            width={240}
            borderColor={props.btnColor}
            disabled={false}
          />
        </Col>
        <Col lg={{ span: 6, order: "first" }} className="about-second-col">
          <div className="about-img-container">
            <img src={MainImgAbout} alt="Família" />
            <div className="about-img-overlay" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
